import React from "react";
import BaseModal from "./BaseModal";
import InfoGrid from "../InfoGrid";

export default function InfoModal({infos,data,open,onClose}){
    return <BaseModal open={open} onClose={onClose}>
        {data && <InfoGrid infos={infos} data={data} color='primary' />}
    </BaseModal>
}